import {TERMS_AND_CONDITIONS_EVENTS} from '@/app/auth/events/TermsAndConditionsEvents';

import Eca from '../components/steps/Eca/Eca';
import ESignature from '../components/steps/ESignature/ESignature';
import NewAccountDisclosurePacket from '../components/steps/NewAccountDisclosurePacket/NewAccountDisclosurePacket';
import PrivacyPolicy from '../components/steps/PrivacyPolicy/PrivacyPolicy';

import {StepDef} from './types';

export const TC_STEPS: StepDef[] = [
  {
    id: 'e-signature',
    Component: ESignature,
    backEventName:
      TERMS_AND_CONDITIONS_EVENTS.SELECT_ONBOARDING_E_SIGNATURE_BACK,
    nextEventName:
      TERMS_AND_CONDITIONS_EVENTS.SELECT_ONBOARDING_E_SIGNATURE_CONTINUE,
  },
  {
    id: 'account-disclosure-packet',
    Component: NewAccountDisclosurePacket,
    backEventName:
      TERMS_AND_CONDITIONS_EVENTS.SELECT_ONBOARDING_ACCOUNT_DISCLOSURE_PACKET_BACK,
    nextEventName:
      TERMS_AND_CONDITIONS_EVENTS.SELECT_ONBOARDING_ACCOUNT_DISCLOSURE_PACKET_CONTINUE,
  },
  {
    id: 'privacy-policy',
    Component: PrivacyPolicy,
    backEventName:
      TERMS_AND_CONDITIONS_EVENTS.SELECT_ONBOARDING_PRIVACY_POLICY_BACK,
    nextEventName:
      TERMS_AND_CONDITIONS_EVENTS.SELECT_ONBOARDING_PRIVACY_POLICY_CONTINUE,
  },
  {
    id: 'eca',
    Component: Eca,
    backEventName: TERMS_AND_CONDITIONS_EVENTS.SELECT_ONBOARDING_ECA_BACK,
    nextEventName: TERMS_AND_CONDITIONS_EVENTS.SELECT_ONBOARDING_ECA_CONTINUE,
  },
];
export const DEFAULT_THRESHOLD = 95;
